export const TiktokPPage = () => {
  return (
    <div className="flex justify-center">
      <div className="px-[15rem] py-[50px] w-[1920px]">
        <div className="text-[#333] text-center font-['Alibaba_PuHuiTi_3.0'] text-[45px] font-bold leading-[120%] tracking-[4.5px] mb-[50px]">
          TIKTOK场景中常见的问题
        </div>
        <div className="flex flex-col mt-[100px]">
          <div className="flex ">
            <Left content="线路不稳定，不合规，线路提供方经常跑路怎么办？" />
            <div className="flex-1" />
          </div>
          <div className="flex mt-[26px]">
            <div className="flex-1" />
            <Right content="我们的底层线路源自国内三大运营商，服务器等均采用腾讯云、火山云等合规大厂服务商，并且光年无界拥有相关合规化资质，且经过备案的优质网络服务商" />
          </div>
          <div className="flex mt-[26px]">
            <Left content="在TikTok直播的时候，遇到不进人，频繁跳红，标黄卡顿，推流不稳，断流掉线的问题怎么办？" />
            <div className="flex-1" />
          </div>
          <div className="flex mt-[26px]">
            <div className="flex-1" />
            <Right content="使用自研K-WAN加速引擎，采用金融级国际专线，延迟低稳定不丢包，确保直播过程中流畅顺滑不掉线" />
          </div>
          <div className="flex mt-[26px]">
            <Left content="在运用TK账号/养号时遇到封号、视频0播放，限流，多账号关联，起号难等问题怎么办？" />
            <div className="flex-1" />
          </div>
          <div className="flex mt-[26px]">
            <div className="flex-1" />
            <Right content="我们严格挑选优质的海外头部网络运营商直采当地真实双ISP住宅IP资源，从源头上杜绝IP共用、网络污染等问题，确保你的账号安全" />
          </div>
          <div className="flex mt-[26px]">
            <Left content="代理软件不会用，配置复杂，反复沟通调试费时间怎么办？" />
            <div className="flex-1" />
          </div>
          <div className="flex mt-[26px]">
            <div className="flex-1" />
            <Right content="我们采用CPE路由器加速盒与软件/端口加速/SDK等多种接入方式，可快速交付，易维护，使用方便简单" />
          </div>
        </div>
      </div>
    </div>
  );
};

const Left = (props: { content: string }) => {
  return (
    <div className="relative w-min inline-block pl-[100px] pr-[30px] py-[27px] bg-gradient-to-br from-sky-200 via-blue-100 to-violet-100/30 rounded-[70px] shadow-[0px_4px_10px_0px_rgba(0,0,0,0.06)]">
      <div className="text-slate-700 text-lg font-light font-['Alibaba_PuHuiTi_3.0'] whitespace-nowrap">
        {props.content}
      </div>
      <img
        src="/imgs/tiktok/left.png"
        className="absolute bottom-[15px] left-0 w-[90px] h-[90px]"
      />
    </div>
  );
};

const Right = (props: { content: string }) => {
  return (
    <div className="relative w-fit max-w-[860px] pr-[100px] pl-[30px] inline-block py-[15px] bg-sky-200 rounded-[70px] shadow-[0px_4px_10px_0px_rgba(0,0,0,0.06)]">
      <div className="text-slate-700 text-lg font-normal font-['Alibaba_PuHuiTi_3.0'] whitespace-pre-line">
        {props.content}
      </div>
      <img
        src="/imgs/tiktok/right.png"
        className="absolute bottom-[15px] right-0 w-[90px] h-[90px]"
      />
    </div>
  );
};
